import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "styled-components";
import "./locales/config/i18n";
import {ThemesColors} from "./themes";
import {store} from "@features/store/store";
import {disableConsole, disableReactDevTools} from "@utils/secure";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

disableConsole();
disableReactDevTools();

root.render(
    <Provider store={store}>
        <ThemeProvider theme={ThemesColors}>
            <App />
            <Toaster position="top-center" />
        </ThemeProvider>
    </Provider>
);

// If you want to start measuring performance in your App, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
